import { FormStore, GlobalStore } from "@roc/feature-app-core";
import { DialogState } from "@roc/ui";
import { action, flow, makeObservable, observable, override } from "mobx";
import { LeadService } from "../../services/leadService";
import { LeadDetailsStore } from "./leadDetailsStore";
import { formatToLocalDateTimeString } from "@roc/feature-utils";

const form = {
  fields: {
    purchasePrice: {
      value: "",
      error: null,
      rule: "numeric",
      message: "The Purchase Price must be a number",
    },
    mortgageAmount: {
      value: "",
      error: null,
      rule: "numeric",
      message: "The Mortgage Amount must be a number",
    },
    interestRate: {
      value: "",
      error: null,
      rule: "numeric",
      message: "The Interest Rate must be a number",
    },
    ltc: {
      value: "",
      error: null,
      rule: "numeric",
    },
    arltv: {
      value: "",
      error: null,
      rule: "numeric",
    },
    ficoScore: {
      value: "",
      error: null,
      rule: "numeric",
      message: "The Fico Score must be a number",
    },
    purchaseDate: {
      value: "",
      error: null,
      rule: "",
    },
    saleDate: {
      value: "",
      error: null,
      rule: "",
    },
    propertyAddress: {
      value: "",
      error: null,
      rule: "required",
      attribute: "Property Address",
    },
    transactionType: {
      value: "",
      error: null,
      rule: "",
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class EditRealEstateTransactionStore extends FormStore {
  protected globalStore: GlobalStore;
  protected leadDetailsStore: LeadDetailsStore;
  protected leadService: LeadService;

  dialogState: DialogState;
  realEstateTransaction: any;
  dialogOpen: any;

  constructor(globalStore: GlobalStore, leadDetailsStore: LeadDetailsStore) {
    super(form, globalStore);
    this.globalStore = globalStore;
    this.leadDetailsStore = leadDetailsStore;
    this.leadService = new LeadService();
    this.dialogOpen = false;

    makeObservable(this, {
      dialogState: observable,
      realEstateTransaction: observable,
      reset: override,
      openAddRealEstateTransaction: flow,
      openEditRealEstateTransaction: flow,
      closeDialog: flow,
      buildRealEstateTransactionFromForm: action,
      dialogOpen: observable,
      setRealEstateTransaction: action,
      saveRealEstateTransaction: flow,
    });
  }

  setRealEstateTransaction(value) {
    this.realEstateTransaction = value;
  }

  reset() {
    super.reset();
    this.realEstateTransaction = null;
  }

  *openEditRealEstateTransaction(realEstateTransaction) {
    this.reset();
    this.realEstateTransaction = realEstateTransaction;
    this.loadForm({
      ...realEstateTransaction,
    });
    this.dialogState = DialogState.EDIT;
    this.dialogOpen = true;
  }

  *openAddRealEstateTransaction() {
    this.reset();
    this.dialogState = DialogState.ADD;
    this.dialogOpen = true;
  }

  *closeDialog() {
    this.dialogOpen = false;
    this.dialogState = null;
    this.reset();
  }

  buildRealEstateTransactionFromForm() {
    const formValues = this.getFormValues();
    const leadId = this.leadDetailsStore?.objectId;

    this.realEstateTransaction = {
      ...this.realEstateTransaction,
      purchasePrice: formValues.purchasePrice,
      mortgageAmount: formValues.mortgageAmount,
      interestRate: formValues.interestRate,
      ltc: formValues.ltc,
      arltv: formValues.arltv,
      ficoScore: formValues.ficoScore,
      propertyAddress: formValues.propertyAddress,
      purchaseDate: formatToLocalDateTimeString(formValues.purchaseDate),
      saleDate: formatToLocalDateTimeString(formValues.saleDate),
      leadId: leadId,
      transactionType: formValues.transactionType
    };
  }

  *saveRealEstateTransaction() {
    try {
      if (this.runFormValidationWithMessage()) {
        this.buildRealEstateTransactionFromForm();
        yield this.leadService.saveRealEstateTransaction(
          this.realEstateTransaction
        );
        this.leadDetailsStore.fetchRealEstateTransactions();
        this.globalStore.notificationStore.showSuccessNotification({
          message: "Real estate transaction successfully saved.",
        });
        this.closeDialog();
      }
    } catch (e) {
      this.closeDialog();
      this.globalStore.notificationStore.showErrorNotification({
        message: "Error while saving the real estate transaction.",
      });
    }
  }
}
